import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=6502d29c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6502d29c')) {
      api.createRecord('6502d29c', component.options)
    } else {
      api.reload('6502d29c', component.options)
    }
    module.hot.accept("./EmptyPage.vue?vue&type=template&id=6502d29c&", function () {
      api.rerender('6502d29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EmptyPage.vue"
export default component.exports